import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { GLOBAL } from '../../app/global';
import { Banner } from '../domain/banner';

@Injectable({
  providedIn: 'root'
})
export class BannerService {

  urlBanner: string;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  /**
   * @author Daniel Pareja Londoño
   * @version 2018-10-08
   * @param httpClient
   */
  constructor(
    public httpClient: HttpClient
  ) { 
    this.urlBanner = GLOBAL.URL_BASE+'sicaBanner';
  }

  /**
   * @author Daniel Pareja Londoño
   * @version 2018-10-10
   * Busca todos los banners
   */
  getDataSicaBanner():Observable<any>{
    return this.httpClient.get(this.urlBanner+'/getDataSicaBanner');
  }

  /**
   * AFVL on Dec 04, 2018: Se optimiza para que sea una consulta paginada.
   * @param parametros - Numero de pagina y tamaño de la pagina.
   * @author Andres Felipe Vargas Lopez
   * @version 2018-10-12
   * Busca los banners ordenados por Orden
   */
  getDataSicaBannerOrderByOrdenAsc(parametros: Banner):Observable<any>{
    return this.httpClient.post(this.urlBanner+'/getDataSicaBannerOrderByOrdenAsc',parametros,this.httpOptions);
  }

  /**
   * @author Daniel Pareja Londoño
   * @version 2018-10-10
   * @param id
   * Busca un banner dado un id
   */
  getSicaBannerById(id:number):any{
    return this.httpClient.get(this.urlBanner+'/getSicaBanner/'+id);
  }

  /**
   * @author Daniel Pareja Londoño
   * @version 2018-10-10
   * @param id
   * Guarda un nuevo Banner
   */
  grabar(banner:Banner): Observable<any>{
    return this.httpClient.post(this.urlBanner+'/saveNewBannerDTO/',banner,this.httpOptions);
  }

  /**
   * @author Daniel Pareja Londoño
   * @version 2018-10-10
   * @param id
   * actualiza un Banner con el orden
   */
  actualizar(banner:Banner): Observable<any>{
    return this.httpClient.post(this.urlBanner+'/actualizarBannerDTO/',banner, this.httpOptions);
  }

  /**
   * @author Daniel Pareja Londoño
   * @version 2018-10-10
   * @param id
   * Obtener formato de fechas
   */
  getFormatoFechas():string{
    return GLOBAL.FORMATO_FECHAS;
  }

  /**
   * @author Daniel Pareja Londoño
   * @version 2018-10-12
   * Busca los banners visibles en la fecha actual ordenados por Orden
   */
  findAllBannersWithAdjuntoByEstadoVisible():Observable<any>{
    return this.httpClient.get(this.urlBanner+'/findAllBannersWithAdjuntoByEstadoVisible',this.httpOptions);
  }

  /**
   * @author Daniel Pareja Londoño
   * @version 2018-10-21
   * Busca los slides visibles en la fecha actual ordenados por Orden
   */
  findSlidesAvailableOrderByOrden():Observable<any>{
    return this.httpClient.get(this.urlBanner+'/findSlidesAvailableOrderByOrden',this.httpOptions);
  }
  
  /**
   * @author Daniel Pareja Londoño
   * @version 2018-10-21
   * Busca los slides visibles ordenados por Orden
   */
  findSlidesActiveOrderByOrden():Observable<any>{
    return this.httpClient.get(this.urlBanner+'/findSlidesActiveOrderByOrden',this.httpOptions);
  }
}
